import React, { StatelessComponent } from 'react';

interface DebugProps {
    data: any;
}

const Debug: StatelessComponent<DebugProps> = props => {
    return (
        <pre>{JSON.stringify(props.data, null, 2)}</pre>
    );
};

export default Debug;
